<template>
    <div class="p-0-18" :id="serviceProductsId">
        <confirmation-popup
            title="Warning"
            message="Are You Sure You Want to Delete This Product?"
            :id="confirmationDialogId" @on-confirm="onSelectedProductDeleteConfirm"></confirmation-popup>
        <div class="ibox-content product-class border-none" v-for="(product,index) of selectedProducts"
             :key="product.id">
            <product v-model="selectedProducts[index]" :currency="currency" :service="service"></product>
        </div>
    </div>
</template>

<script>
import {EventBus} from "@/events/event-bus";
import {getServiceProductsByIds, addTaxRateInProduct} from "@/modules/Services/api/products";
import Product from "./Product.vue";
import ConfirmationPopup from "../../../common/components/ConfirmationPopup.vue";

export default {
    name: "Products",
    components: {ConfirmationPopup, Product},
    props: {
        value: {
            type: Array,
        },
        service: {
            type: Object,
            required: true
        },
        currency: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            serviceProductsId: `service_products_${this.service.service_id}_${this.service.clone}`,
            confirmationDialogId: `product-confirmation${this.service.service_id+this.service.clone}`,
            products: [],
            selectedProducts: [],
            taxRates: [],
            productMandatory: '',
            showBillingInfoCondition: '',
            for_products: '',
            serviceName: '',
            selectedProductIds: [],
            errorMessage: "Please enter numbers and a decimal point only, e.g. 50.25",
            description: "",
            pricePerUnit: "",
            costPricePerUnit: '',
            discount: "",
            discount_type: "%",
            subTotal: "",
            suppliedBy: "",
            MarkupPerUnit: "",
            markupType: "%",
            quantity: (1).toFixed(2),
            quantityError: false,
            costError: false,
            saleError: false,
            discountError: false,
            toBeDeletedProductId: null,
        }
    },

    created() {
        EventBus.$on('onServiceProductsSelected', (products,service) => {
            if (this.service.service_id ===service.service_id && this.service.clone === service.clone){
                for (let product of products ) {
                    product.quantity = product.ltr ?? "1.00";
                    product.id = product.product_id;
                    product.costPricePerUnit = product.cost
                    product.salePricePerUnit = parseFloat(product.sale_price).toFixed(2)
                    product.sub_total = product.sub_total ?? 0;
                    product.discount = product.discount
                    product.discountType = product.discount_type
                    product.suppliedBy = product.supplied_by ?? "company"
                    this.selectedProducts.push(product)
                }
            }
        });
        EventBus.$on('onProductsSelected', (products,service_id,clone) => {
                if (service_id == this.service.service_id && clone == this.service.clone) {
                    getServiceProductsByIds(this.service.service_id, products)
                        .then(response => {

                            for (let product of response.data.products) {

                                let exists = this.selectedProducts.find(prod => prod.id === product.id)

                                product.quantity = product.default_qty ?? "1.00";
                                product.costPricePerUnit = product.product_cost
                                product.salePricePerUnit = parseFloat(product.sub_total).toFixed(2)
                                product.sub_total = product.sub_total ?? 0;
                                product.discount = "0.00"
                                product.discountType = "%"
                                product.suppliedBy = product.supplied_by ?? "company"

                                if (!exists)
                                    this.selectedProducts.push(product)
                            }
                            this.for_products = response.data.for_products;
                            this.serviceName = response.data.serviceName;
                            this.costPricePerUnit = response.data.costPricePerUnit;
                            this.productMandatory = response.data.productMandatory;
                            this.productMandatory = this.productMandatory ? 'required' : '';
                            this.showBillingInfoCondition = response.data.showBillingInfoCondition;
                        })
                        .catch(e => {

                        })
                }
        });

        EventBus.$on('onSelectedProductDelete', (productId,service_id,clone) => {
            if (this.service.service_id === service_id && this.service.clone === clone){
            $(`#${this.confirmationDialogId}`).modal('show')
            this.toBeDeletedProductId = productId
            }
        });
    },

    methods: {

        addTax(productId) {
            if (val === 'add') {
                popupi('New Tax Rate', url + '?select_id=' + productId);
                $('#popupi').modal('show');
            }
        },

        onSelectedProductDeleteConfirm() {
            let product = this.selectedProducts.find(product => product.id === this.toBeDeletedProductId)
            this.selectedProducts.splice(this.selectedProducts.indexOf(product), 1)
            EventBus.$emit('onSelectedProductDeleteConfirm', this.toBeDeletedProductId)
        },
    },

    watch: {
        selectedProducts: {
            handler: function (value) {
                this.$emit('input', value)
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.validation {
    display: inline-block !important;
}
</style>